import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getXsrfTokenFromCookie } from '@dhl/receiver-axios'

const httpLink = createHttpLink({
  uri: '/api/graphql',
})

const authLink = setContext((operation, { headers }) => ({
  headers: {
    ...headers,
    'X-XSRF-TOKEN': getXsrfTokenFromCookie(),
  },
}))

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  link: ApolloLink.from([authLink, httpLink]),
})
